import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import SearchBox from '../containers/SearchBox';
import image404 from '../../images/404-img.svg';
import routeList from '../../routes/routeList';
import ButtonReadings from '../containers/Buttons';

const NotFound = ({ pageTitle }) => (
  <div className="full-wrapper flex-grow-1 subpage-margins">
    <DocumentTitle title={pageTitle} />
    <div className="content-wrapper">
      <SearchBox />
      <section className="not-found-page">
        <Row>
          <Col xs={12} sm={6} md={6}>
            <div>
              <h2>Ups... :(</h2>
              <h6>Nie ma strony o takim adresie</h6>
              <Link to={routeList.home}>
                <ButtonReadings text="Przejdź do strony głównej" color="primary" />
              </Link>
            </div>
          </Col>
          <Col xs={12} sm={6} md={6} className="justify-content-center">
            <img src={image404} alt="Obrazek dla strony 404" className="img-fluid" />
          </Col>
        </Row>
      </section>
    </div>
  </div>
);

NotFound.defaultProps = {
  title: 'Lektury'
};
NotFound.propTypes = {
  title: PropTypes.string
};

export default NotFound;
